if (!customElements.get('product-addon')) {
  customElements.define(
    'product-addon',
    class ProductAddon extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-add]');
        this.label = this.querySelector('[data-label]');
        this.variantInput = this.querySelector('[data-variant]');
        this.priceEl = this.querySelector('[data-price]');
        this.message = this.querySelector('.product-addon__message');
        this.buttonLabel = this.dataset.buttonLabel || 'Add';

        if (this.button) this.button.addEventListener('click', this.onAdd.bind(this));
        if (this.variantInput && this.variantInput.tagName === 'SELECT') {
          this.variantInput.addEventListener('change', this.onVariantChange.bind(this));
        }
      }

      connectedCallback() {
        // Keep the pickup availability block directly under the add-on card
        const scope = this.closest('product-info') || document;
        const pickup = scope.querySelector('pickup-availability');
        if (pickup && this.nextElementSibling !== pickup) {
          this.insertAdjacentElement('afterend', pickup);
        }
      }

      onVariantChange() {
        const option = this.variantInput.selectedOptions[0];
        if (!option) return;
        if (option.dataset.price && this.priceEl) this.priceEl.textContent = option.dataset.price;
        if (option.dataset.shortPrice && this.label) {
          this.label.textContent = `${this.buttonLabel} +${option.dataset.shortPrice}`;
        }
        this.hideMessage();
      }

      getCartElement() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      async onAdd() {
        const id = this.variantInput ? this.variantInput.value : null;
        if (!id) return;

        this.button.setAttribute('disabled', '');
        this.button.classList.add('loading');
        this.hideMessage();

        const cart = this.getCartElement();
        const body = { id, quantity: 1 };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(body),
          });
          const data = await response.json();

          if (data.status) {
            throw new Error(data.description || data.message || 'Could not add to cart');
          }

          if (cart && typeof cart.renderContents === 'function') {
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(this.button);
            cart.renderContents(data);
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-addon',
              productVariantId: id,
              cartData: data,
            });
          }

          this.showMessage('Added to your cart', false);
          this.classList.add('product-addon--added');
          window.setTimeout(() => this.classList.remove('product-addon--added'), 2500);
        } catch (error) {
          console.error(error);
          this.showMessage(error.message || 'Could not add to cart', true);
        } finally {
          this.button.removeAttribute('disabled');
          this.button.classList.remove('loading');
        }
      }

      showMessage(text, isError) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.classList.toggle('product-addon__message--error', !!isError);
        this.message.hidden = false;
      }

      hideMessage() {
        if (!this.message) return;
        this.message.hidden = true;
        this.message.textContent = '';
      }
    }
  );
}
